const colorBuffer = document.querySelector('.color-buffer');
const colorViolet = document.querySelector('.buffer-violet');
const windowHeight = document.documentElement.clientHeight;

const colorBlock = (scrollY) => {
  if (colorBuffer.getBoundingClientRect().top <= 0) {
    if (-(colorBuffer.getBoundingClientRect().top / 1000) <= 0.1) {
      colorBuffer.style.opacity = null;
      colorViolet.style.opacity = null;
    } else if (-(colorBuffer.getBoundingClientRect().top / 1000) <= 1) {
      colorBuffer.style.opacity = `${-(colorBuffer.getBoundingClientRect().top / 1000)}`;
      colorViolet.style.opacity = `${-(colorBuffer.getBoundingClientRect().top / 1000)}`;
    } else {
      colorBuffer.style.opacity = '1';
      colorViolet.style.opacity = '1';
    }
  } else {
    colorBuffer.style.opacity = null;
    colorViolet.style.opacity = null;
  }
}

const changeColor = () => {
  if (colorBuffer) {
    let scrollY = window.pageYOffset;
    colorBlock(scrollY);

    window.addEventListener('scroll', () => {
      scrollY = window.pageYOffset;
      colorBlock(scrollY);
    });

    window.addEventListener('resize', () => {
      scrollY = window.pageYOffset;
      colorBlock(scrollY);
    });
  }
}

export {changeColor};
